import React from 'react';

// import axios from 'axios';

import fileIcons from '../../../../../../../constants/fileIcons';
import getResizedImageUrl from '../../../../../../../helpers/getResizedImageUrl';
import classes from './styles.module.scss';

export default function Attachment({ attachment }) {
  const fileExtension = attachment.fileName.split('.').pop().toLowerCase();

  const isImage = attachment.mimeType?.includes('image');
  const attachmentUrl = isImage
    ? getResizedImageUrl({
        url: `feed/${attachment.fileName}`,
        width: 1000,
      })
    : attachment.url;

  const handleDownload = async (event) => {
    event.preventDefault();
    const downloadName = attachment.displayName || attachment.fileName;
    const separator = attachmentUrl.includes('?') ? '&' : '?';
    const cacheBustedUrl = `${attachmentUrl}${separator}_dl=${Date.now()}`;

    try {
      const response = await fetch(cacheBustedUrl, {
        mode: 'cors',
        credentials: 'omit',
        cache: 'no-store',
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = downloadName;
      link.rel = 'noopener';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error('Attachment download failed:', error);
      window.open(attachmentUrl, '_blank', 'noopener,noreferrer');
    }
  };

  /*   const getFileInfo = useCallback(async () => {
    try {
      const response = await axios.head(attachment.url);
      console.log(response.data);
    } catch (error) {
      console.log(error);
    }
  }, [attachment.url]);

  useEffect(() => {
    getFileInfo();
  }, [getFileInfo]); */

  return (
    <li className={classes.Attachment}>
      <img src={fileIcons[fileExtension]} alt="File" />
      <h4>{attachment.displayName}</h4>
      <div className={classes.links}>
        <span>{(attachment.fileSize / 1024).toFixed(2)}kb</span>
        <a href={attachmentUrl} target="_blank" rel="noreferrer">
          View
        </a>
        <a
          href={attachmentUrl}
          onClick={handleDownload}
          download={attachment.displayName || attachment.fileName}
        >
          Download
        </a>
      </div>
    </li>
  );
}
